import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {faPen} from '@fortawesome/free-solid-svg-icons';
import { GeneralService } from '../../services/general.service';
import { LandlineService } from '../../services/landline.service';
import { NormalizadorService } from '../../services/normalizador.service';
import { ShoppingCartService } from '../../services/shopping-cart-service';
import { LandlineConfigurationListener } from '../../interface/landline-configuration-listener';
import { Rate } from '../../interface/rate';
import { LandlineConfigurationModel } from '../../interface/landline-configuration-model';

@Component({
    selector: 'app-landline-configuration',
    templateUrl: './landline-configuration.component.html',
    styleUrls: ['./landline-configuration.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class LandlineConfigurationComponent implements OnInit {
    @Input() listener: LandlineConfigurationListener;
    @Input() rate: Rate;
    @Output() editRateParent = new EventEmitter<boolean>();

    public faPen = faPen;

    public formGroup: FormGroup;
    public model = new LandlineConfigurationModel();
    public formularioCobertura: any;
    public tipoAlta: string;
    public providers = [];

    constructor(
        private formBuilder: FormBuilder,
        private generalService: GeneralService,
        private landlineService: LandlineService,
        private normalizadorService: NormalizadorService,
        private shoppingCartService: ShoppingCartService
    ) {
        this.normalizadorService.getResultadoCobertura()
            .subscribe(data => {
                this.formularioCobertura = data;
            });

        this.model.type_operation = 'registration';
    }

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            type_operation: [this.model.type_operation, Validators.required],
            phone_portability: [this.model.phone_portability],
            operator_portability: [this.model.operator_portability],
            cp_vat: [this.model.cp_vat],
            cp_price: [this.model.cp_price],
            cp_price_without_vat: [this.model.cp_price_without_vat]
        });

        this.landlineService.getProviders()
            .subscribe((response: any) => {
                if (response) {
                    this.providers = response.msg;
                }
            });

        this.generalService.getEmptyFormLandlineConfiguration()
            .subscribe((data: any) => {
                if (data != null) {
                    this.model = data;
                    this.formGroup.get('type_operation').patchValue(this.model.type_operation);
                    this.formGroup.get('phone_portability').patchValue(this.model.phone_portability);
                    this.formGroup.get('operator_portability').patchValue(this.model.operator_portability);
                    this.formGroup.get('cp_vat').patchValue(this.model.cp_vat);
                    this.formGroup.get('cp_price').patchValue(this.model.cp_price);
                    this.formGroup.get('cp_price_without_vat').patchValue(this.model.cp_price_without_vat);

                    this.changeTypeOperation();
                }
            });
    }

    changeTypeOperation() {
        if (this.model.type_operation === 'registration') {
            this.tipoAlta = 'registration';
            this.formGroup.get('phone_portability').clearValidators();
            this.formGroup.get('operator_portability').clearValidators();
        } else if (this.model.type_operation === 'migration') {
            this.tipoAlta = 'migration';
            this.formGroup.get('phone_portability').setValidators([
                Validators.required,
                Validators.pattern('[0-9 ]*'),
                Validators.minLength(9),
                Validators.maxLength(9)
            ]);
            this.formGroup.get('phone_portability').disable();
            this.formGroup.get('operator_portability').patchValue('');
        } else {
            // this.model.phone_portability = '';
            this.tipoAlta = 'portability';
            this.formGroup.get('phone_portability').setValidators([
                Validators.required,
                Validators.pattern('[0-9 ]*'),
                Validators.minLength(9),
                Validators.maxLength(9)
            ]);
            this.formGroup.get('operator_portability').setValidators(Validators.required);
        }

        this.shoppingCartService.getShoppingCart().updateFijo(this.formGroup);
        this.formGroup.get('phone_portability').updateValueAndValidity();
        this.formGroup.get('operator_portability').updateValueAndValidity();
    }

    editRate() {
        this.rate = null;
        this.editRateParent.emit();
    }

    validate() {
        this.formGroup.markAllAsTouched();
        this.formGroup.updateValueAndValidity();
        this.model.phone_portability = this.formGroup.get('phone_portability').value;
        this.model.operator_portability = this.formGroup.get('operator_portability').value;

        if (this.formGroup.valid) {
            this.listener.onSuccessfulValidation(this.model);
            this.formularioCobertura.get('portabilidadFijo').patchValue(this.model.phone_portability);
            this.formularioCobertura.get('serviceProviderFijo').patchValue(this.model.operator_portability);
            this.formularioCobertura.get('tipoAltaFijo').patchValue(this.tipoAlta);
            this.formularioCobertura.get('cp_vat').patchValue(this.model.cp_vat);
            this.formularioCobertura.get('cp_price').patchValue(this.model.cp_price);
            this.formularioCobertura.get('cp_price_without_vat').patchValue(this.model.cp_price_without_vat);
            this.normalizadorService.setResultadoCobertura(this.formularioCobertura);
        } else {
            const elements: any = document.getElementsByClassName('mat-input-element ng-invalid');

            if (elements.length > 0) {
                elements[0].focus();
            }
        }
    }

    thereIsOffer(rate: Rate, name : string) : boolean {        
        return (rate && rate.offers && rate.offers.length && rate.offers[0][name]);  
    }
}
